import React, { createContext, useReducer } from 'react';
import { SCANNED_KITS_ACTION } from '../enums';
import { KitPayload } from '@/interfaces';

export const ScannedKitsContext = createContext<any>(null);

interface ScannedKitsState {
  queueScannedKits: KitPayload[];
}

interface ScannedKitsActionReducer {
  type: SCANNED_KITS_ACTION;
  payload: KitPayload[];
}

const initialState: ScannedKitsState = {
  queueScannedKits: [],
};

export const scannedKitsReducer = (
  state: ScannedKitsState = initialState,
  action: ScannedKitsActionReducer,
) => {
  const handleCreate = (
    state: ScannedKitsState,
    action: ScannedKitsActionReducer,
  ) => {
    if (action.type) {
      switch (action.type) {
        case SCANNED_KITS_ACTION.ADD_TO_QUEUE:
          const newScannedKits = action.payload;
          const queueScannedKits = state.queueScannedKits;
          // const isExisted = newScannedKits.find(
          //   k => k.serial === newScannedKit.kitSerial,
          // );
          // if (!isExisted) {
          //   newScannedKits.push(newScannedKit);
          // }

          const newQueueScannedKits = [
            ...new Set(queueScannedKits.concat(newScannedKits)),
          ];

          return { ...state, queueScannedKits: newQueueScannedKits };

        default:
          return state;
      }
    }
    return state;
  };

  const handleDelete = (
    state: ScannedKitsState,
    action: ScannedKitsActionReducer,
  ) => {
    switch (action.type) {
      case SCANNED_KITS_ACTION.CLEAR_QUEUE:
        return { ...state, queueScannedKits: [] };

      default:
        return state;
    }
  };

  switch (action.type) {
    case SCANNED_KITS_ACTION.ADD_TO_QUEUE:
      return handleCreate(state, action);

    case SCANNED_KITS_ACTION.CLEAR_QUEUE:
      return handleDelete(state, action);

    default:
      return state;
  }
};

export const ScannedKitsProvider = (props: { children: React.ReactNode }) => {
  const { children } = props;
  const [queuedScannedKitsState, scannedKitsDispatch] = useReducer(
    scannedKitsReducer,
    initialState,
  );

  return (
    <ScannedKitsContext.Provider
      value={{
        queueScannedKits: queuedScannedKitsState.queueScannedKits,
        scannedKitsDispatch,
      }}
    >
      {children}
    </ScannedKitsContext.Provider>
  );
};
